angular.module('impactx.requestItem').controller('EditRequestItemCancelCtrl', [
    '$scope',
    'dataGen',
    '$mdDialog',
    'themeFactory',
    'item',
    'trns',
    EditRequestItemCancelCtrl
]);

function EditRequestItemCancelCtrl($scope, dataGen, $mdDialog, themeFactory, item, trns)
{
    const self = this;
    $scope.errorList = [];
    $scope.theme = themeFactory.getTheme();

    $scope.item = item;
    $scope.trns = trns;

    $scope.save = function () {
        $mdDialog.hide($scope.item);
    };

    $scope.cancel = function () {
        $mdDialog.cancel();
    };
}
